export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.woff2?1bac2991f3dbfa237aecb4bcc41ad26f";